const currencySymbols: Record<string, string> = {
    USD: '$', EUR: '€', GBP: '£', JPY: '¥', AUD: 'A$', CAD: 'C$',
    CHF: 'CHF', CNY: '¥', IDR: 'Rp', INR: '₹', KRW: '₩', MXN: 'MX$',
    BRL: 'R$', ZAR: 'R', SGD: 'S$', HKD: 'HK$', NOK: 'kr', SEK: 'kr',
    DKK: 'kr', NZD: 'NZ$', THB: '฿', AED: 'AED', SAR: 'SAR', PLN: 'zł',
    TRY: '₺', RUB: '₽', ARS: 'ARS', COP: 'COP', PHP: '₱', MYR: 'RM',
};

function getSettings(): { currency: string; pricesFormat: string } {
    try {
        const stored = localStorage.getItem('currentProperty');
        if (stored) {
            const property = JSON.parse(stored);
            return {
                currency: property.currency || 'USD',
                pricesFormat: property.pricesFormat || '$1,234.56',
            };
        }
    } catch {}
    return { currency: 'USD', pricesFormat: '$1,234.56' };
}

function parseFormat(format: string): {
    symbolBefore: boolean;
    spaceBetween: boolean;
    thousandsSep: string;
    decimalSep: string;
} {
    // Determine symbol position: does format start with $ or end with $
    const trimmed = format.trim();
    const symbolBefore = trimmed.startsWith('$');

    // Determine space between symbol and number
    let spaceBetween = false;
    if (symbolBefore) {
        spaceBetween = trimmed.length > 1 && trimmed[1] === ' ';
    } else {
        spaceBetween = trimmed.length > 1 && trimmed[trimmed.length - 2] === ' ';
    }

    // Extract the number part to determine separators
    const numberPart = format.replace('$', '').trim(); // e.g. "1,234.56" or "1.234,56" or "1 234,56"

    // The decimal separator is the last non-digit separator before the last 2 digits
    // In all formats the decimal part is always 2 digits at the end
    const sepChar = numberPart.slice(-3, -2); // "." or ","

    const decimalSep = sepChar;
    // Thousands separator is the other separator in the number
    const beforeDecimal = numberPart.slice(0, -3); // e.g. "1,234" or "1.234" or "1 234"
    let thousandsSep = ',';
    if (beforeDecimal.includes('.')) thousandsSep = '.';
    else if (beforeDecimal.includes(' ')) thousandsSep = ' ';
    else if (beforeDecimal.includes(',')) thousandsSep = ',';

    return { symbolBefore, spaceBetween, thousandsSep, decimalSep };
}

export function formatPrice(value: number | string | null | undefined): string {
    if (value == null || value === '') return '0.00';

    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return '0.00';

    const { currency, pricesFormat } = getSettings();
    const symbol = currencySymbols[currency] || currency;
    const { symbolBefore, spaceBetween, thousandsSep, decimalSep } = parseFormat(pricesFormat);

    const absValue = Math.abs(numValue);
    const fixed = absValue.toFixed(2);
    const [intPart, decPart] = fixed.split('.');

    // Add thousands separators
    const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    const formattedNumber = withThousands + decimalSep + decPart;

    const space = spaceBetween ? ' ' : '';
    const negative = numValue < 0 ? '-' : '';

    if (symbolBefore) {
        return `${negative}${symbol}${space}${formattedNumber}`;
    } else {
        return `${negative}${formattedNumber}${space}${symbol}`;
    }
}

export function getCurrencySymbol(): string {
    const { currency } = getSettings();
    return currencySymbols[currency] || currency;
}
